import 'jquery-mask-plugin';

export default class DeliveryLocationPopover {

	constructor() {

		this.$button = $.hook( 'delivery-location-button' );
		this.$content = $.hook( 'delivery-location-content' );
		this.$form = $.hook( 'delivery-location-form' );
		this.$input = $.hook( 'delivery-location-input' );
		this.$close = $.hook( 'deliver-location-close' );
		this.$overlay = $.hook( 'delivery-location-overlay');

		this.bindEvents();

	}

	togglePopover() {

		this.$content.toggleClass( 'u-hidden' );
		this.$overlay.toggleClass( 'u-hidden' );

		if ( !this.$content.hasClass( 'u-hidden' ) ) {

			setTimeout(() => {

				this.$input.trigger( 'focus' );

			}, 100);

		}

	}

	closePopover() {

		this.$content.addClass( 'u-hidden' );
		this.$overlay.addClass( 'u-hidden' );

	}

	onOpenClick( e ) {

		e.preventDefault();

		this.togglePopover();

	}

	onCloseClick( e ) {

		e.preventDefault();

		this.closePopover();

	}

	async onSubmit( e ) {

		e.preventDefault();

		const localResponse = await $.ajax({
			url: window.mivaJS.Miva_AJAX_URL,
			data: {
				Verb: 'Create_Cookie',
				Cookie_Data: this.$input.val(),
				Cookie_Name: `mvps-${mivaJS.Store_Code}-user-zip`
			}
		});

		window.location.reload();

	}

	bindEvents() {

		this.$button.on( 'click', ( e ) => this.onOpenClick( e ) );

		this.$close.on( 'click', ( e ) => this.onCloseClick( e ) );
		this.$overlay.on( 'click', ( e ) => this.onCloseClick( e ) );

		this.$form.on( 'submit', ( e ) => this.onSubmit( e ) );

		this.$input.mask( '00000-000' );

	}

}
